import { Link } from "react-router-dom";
import { Leaf, Mail } from "lucide-react";

const footerLinks = {
  product: [
    { label: "Browse Services", href: "/browse" },
    { label: "For Practitioners", href: "/pricing" },
    { label: "For Businesses", href: "/pricing" },
    { label: "Pricing", href: "/pricing" },
  ],
  company: [
    { label: "About Us", href: "/about" },
    { label: "Careers", href: "/careers" },
    { label: "Blog", href: "/blog" },
    { label: "Contact", href: "/contact" },
  ],
  support: [
    { label: "Help Center", href: "/help" },
    { label: "Terms of Service", href: "/terms" },
    { label: "Privacy Policy", href: "/privacy" },
    { label: "FAQ", href: "/faq" },
  ],
};

export function Footer() {
  return (
    <footer className="bg-foreground text-background" role="contentinfo" aria-label="Site footer">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-6" aria-label="Wellness Connect - Go to homepage">
              <div className="w-10 h-10 rounded-xl gradient-primary flex items-center justify-center">
                <Leaf className="w-5 h-5 text-primary-foreground" aria-hidden="true" />
              </div>
              <span className="font-display text-xl font-semibold">Wellness Connect</span>
            </Link>
            <p className="text-background/80 mb-6 max-w-sm">
              Connecting wellness seekers with the best practitioners and wellness centers worldwide.
            </p>
          </div>

          <nav aria-label="Product links">
            <h3 className="font-display text-lg font-semibold mb-4">Product</h3>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.href + link.label}>
                  <Link
                    to={link.href}
                    className="text-background/80 hover:text-primary hover:underline focus:text-primary focus:underline focus:outline-none transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Company links">
            <h3 className="font-display text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-background/80 hover:text-primary hover:underline focus:text-primary focus:underline focus:outline-none transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Support links">
            <h3 className="font-display text-lg font-semibold mb-4">Support</h3>
            <ul className="space-y-3">
              {footerLinks.support.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-background/80 hover:text-primary hover:underline focus:text-primary focus:underline focus:outline-none transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        {/* Contact Info */}
        <div className="mt-12 pt-8 border-t border-background/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex flex-wrap justify-center md:justify-start gap-6 text-sm text-background/80">
              <a
                href="mailto:hello@wellnessconnect.com"
                className="flex items-center gap-2 hover:text-primary hover:underline focus:text-primary focus:underline focus:outline-none transition-colors min-h-[44px]"
              >
                <Mail className="w-4 h-4" aria-hidden="true" />
                hello@wellnessconnect.com
              </a>
            </div>
            <p className="text-sm text-background/60">
              © {new Date().getFullYear()} Wellness Connect. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
